import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { configurationProfileSchema } from '../schemas/configuration-profile.schema';

/**
 * Returns a paginated response for Configuration Profiles
 * @param params Paged Collection Params
 * @returns Paged Collection of Configuration Profiles
 */
export function getConfigurationProfiles(
  this: unknown,
  params?: PagedCollectionParams
) {
  const requestUrl = `${
    fleetEnvironment.resolve(this).configurationProfilesUrl
  }?${params ? params.urlParams : ''}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(configurationProfileSchema)));
}
